import React from 'react'
import PropTypes from 'prop-types'
import { FormattedHTMLMessage } from 'react-intl'
import { Error } from './FormErrorStyle'

const FormError = ({ error, name, fallbackTranslate }) => (
  <Error id={`${name}Error`} role="alert" color="danger" transparent>
    <FormattedHTMLMessage
      id={error.id}
      values={error.values}
      defaultMessage={fallbackTranslate}
    />
  </Error>
)

FormError.propTypes = {
  error: PropTypes.shape({
    id: PropTypes.string.isRequired,
    values: PropTypes.shape({}),
  }).isRequired,
  name: PropTypes.string.isRequired,
  fallbackTranslate: PropTypes.string,
}

export default FormError
